export default `<svg xmlns="http://www.w3.org/2000/svg" width="8.625" height="5.006" viewBox="0 0 8.625 5.006" class="icon-chevron-down">
  <defs>
    <style>
      .icon-chevron-down .a{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px;}
    </style>
  </defs>
  <g transform="translate(1.062 1.061)">
    <path class="a" d="M6.5,0,3.252,3.2,0,0"/>
  </g>
</svg>`;
